import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, AfterViewInit, Input, OnChanges, SimpleChanges, Inject, PLATFORM_ID } from '@angular/core';

//  environments
import { environment } from 'src/environments/environment';

// interfaces
import { IUserInfo } from 'src/app/core/interfaces/user/user-info';
import { MetaDataPayment } from 'src/app/core/union-Intersection-types/meta-data';

// services
import { AuthService } from 'src/app/core/services/user/auth.service';
import { GlobleService } from 'src/app/core/services/globle.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// enums
import { usersType } from 'src/app/core/enums/user/user-type';
import { PAYMENT_TYPE } from 'src/app/core/enums/payment/payment-types';

declare var goSell: any

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit, OnChanges, AfterViewInit {

   /************ Inputs ************/
  @Input('type') type: PAYMENT_TYPE
  @Input('soldItemInfo') soldItemInfo: any
  @Input('metadata') metadata: MetaDataPayment
  @Input('redirect') redirect: string | null = null

  /************ Accessors ************/
  /**
   * _userInfo
   */
  private get _userInfo(): BehaviorSubject<IUserInfo> {
    return this._auth.userInfo;
  }


  constructor(
    private _g: GlobleService,
    private _auth: AuthService,
    private _api: ApiResponseService,
    @Inject(PLATFORM_ID) private platformId: any,
  ) { }
  
  ngOnChanges(changes: SimpleChanges): void {
    // console.log(this.metadata, this.type)
  }
  
  ngOnInit(): void {}

  ngAfterViewInit(): void {

    /**
     * 
     */
    document.documentElement.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';    
    
    //
    switch(this.type) {
      case PAYMENT_TYPE.booking:
      case PAYMENT_TYPE.deposit:
        
        // ES6 Destructuring nested Object
        const { owner: { id, type } } = this.soldItemInfo;

        if (type == usersType.office) {

          this._api.marketPlaceCheckOfficeMarket(id).subscribe(
            res => {
              
              // ES6 Destructuring nested Object
              const { isMarketPlace, destination_id } = res || {};
              
              if (isMarketPlace) {
                this.metadata = {
                  destination_id,
                  ...this.metadata,
                } 
              }

              if (isPlatformBrowser(this.platformId)) {
                //
                this.initGoSellConfig()
  
                //
                setTimeout(() => goSell.openPaymentPage(), 1500)

              }
              
            }
          )

          break;
          
        }
        
      default:
        if (isPlatformBrowser(this.platformId)) {

          this.initGoSellConfig()
          setTimeout(() => goSell.openPaymentPage(), 1500)

        }
        break;
    }


  }

  /**
   * 
   * @returns 
   */
  private _customerInfo() {

    // ES6 Destruction
    const { fullname, email, phone, country } = this._userInfo.value;

    /**
     * init
     */
    const customer = {};

    /**
     * 
     */
    if (email) customer['email'] = email;
    if (phone) customer['phone'] = {
      number: phone,
      country_code: country.countryCode
    };
    
    /**
     * 
     */
    const [firstName, lastName] = fullname.split(" ");

    if (firstName) customer['first_name'] = firstName;
    if (lastName) customer['last_name'] = lastName;

    /**
     * 
     */
    return customer;

  }

  //
  initGoSellConfig() {

    const config = {
      containerID: "payment_gosell",
      gateway: {
        language: "ar",
        contactInfo:true,
        customerCards: true,
        saveCardOption:false,
        notifications:'standard',
        supportedCurrencies:"SAR",
        publicKey: environment.PAYMENT_PUBLISHABLE_API_KEY,
        supportedPaymentMethods: ['MADA', 'MASTERCARD', 'VISA', 'APPLE_PAY'],
        labels:{
          cvv:"CVV",
          actionButton:"دفع",
          cardHolder:"االاسم",
          expirationDate:"MM/YY",
          cardNumber:"رقم البطاقة",
        },
        style: {
          base: {
            color: "#535353",
            lineHeight: "18px",
            fontFamily: "sans-serif",
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "rgba(0, 0, 0, 0.26)",
              fontSize: "15px",
            },
          },
          invalid: {
            color: "red",
            iconColor: "#fa755a ",
          },
        },        
        callback:(response: any) => {
          console.log('response');
        },
        onClose: () => {
          console.log("onClose Event");
        },
      },      
      transaction:{
        mode: 'charge',
         charge:{
            saveCard: false,
            threeDSecure: true,
            statement_descriptor: "Sample",
            description: this.metadata?.description,
            metadata:{
              ...this.metadata,
              client: this._g.CorrectUserId,
            },
            receipt:{
              email: false,
              sms: true
            },
            post: `${environment.SERVER}/payment`,
            redirect: `${environment.APP_URL}/${this.redirect && this.redirect}`,
          }
       } ,
       customer: this._customerInfo(),
       order:{
         currency:"SAR",
         amount: this.metadata?.total,
      },
    }

    /**
     * 
     */
    goSell.config(config);

  }

}
// 